import { RequestResults } from "../../common/RequestStatus";
import { RootState } from "../../store";
import { IUserRole, PermissionConfig } from "./IAuthState";

export const selectAuthRequestStatus = (state: RootState): RequestResults =>
  state.auth.authStatus;

export const selectAuthUserInfo = (state: RootState) =>
  state.auth.userAuthInfo;

export const selectAuthStatus = (state: RootState): boolean =>
  state.auth.authenticated;

export const selectUserRole = (state: RootState): IUserRole | undefined => state.auth.userAuthInfo?.role;